/* Generated fallback taxonomy for products whose Shopify tags are empty. */
(function () {
  var map = {
  "amouage-guidance": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:incense",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:oud",
    "note:jasmine",
    "note:gourmand",
    "note:vanilla"
  ],
  "amouage-guidance-46": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:incense",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:jasmine",
    "note:gourmand",
    "note:iris",
    "note:vanilla"
  ],
  "amouage-line-618": [
    "gender:unisex",
    "note:floral",
    "note:gourmand",
    "note:musk",
    "note:rose",
    "note:vanilla",
    "note:incense",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:milk",
    "note:leather",
    "note:fruity"
  ],
  "amouage-love-hibiscus": [
    "gender:unisex",
    "note:incense",
    "note:salt",
    "note:floral",
    "note:smoky",
    "note:woody",
    "note:aquatic",
    "note:citrus",
    "note:gourmand",
    "note:iris",
    "note:vanilla",
    "note:fruity"
  ],
  "amouage-outlands": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:incense",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:oud",
    "note:musk",
    "note:citrus",
    "note:gourmand",
    "note:vanilla"
  ],
  "amouage-purpose-50": [
    "gender:unisex",
    "note:suede",
    "note:rose",
    "note:incense",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:vetiver",
    "note:citrus",
    "note:gourmand",
    "note:vanilla",
    "note:leather",
    "note:fruity",
    "note:jasmine",
    "note:fresh",
    "note:cedar",
    "note:iris"
  ],
  "amouage-reflection-45": [
    "gender:unisex",
    "note:incense",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:jasmine",
    "note:fresh",
    "note:cedar",
    "note:gourmand",
    "note:iris",
    "note:vetiver",
    "note:vanilla",
    "note:fruity"
  ],
  "bdk-parfums-citrus-riviera": [
    "gender:unisex",
    "note:salt",
    "note:floral",
    "note:woody",
    "note:musk",
    "note:jasmine",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:fig",
    "note:vetiver",
    "note:fruity"
  ],
  "bdk-parfums-gris-charnel": [
    "gender:unisex",
    "note:spicy",
    "note:woody",
    "note:gourmand",
    "note:fig",
    "note:iris",
    "note:vetiver",
    "note:fruity"
  ],
  "bdk-parfums-gris-charnel-extrait": [
    "gender:unisex",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:cedar",
    "note:gourmand",
    "note:fig",
    "note:iris",
    "note:vetiver",
    "note:vanilla",
    "note:fruity"
  ],
  "bdk-parfums-impadia": [
    "gender:feminine",
    "note:rose",
    "note:floral",
    "note:woody",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:vanilla"
  ],
  "bdk-parfums-pas-ce-soir": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:jasmine",
    "note:fresh",
    "note:citrus",
    "note:fruity"
  ],
  "bdk-parfums-rouge-smoking": [
    "gender:unisex",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:musk",
    "note:citrus",
    "note:gourmand",
    "note:vanilla",
    "note:fruity"
  ],
  "bdk-parfums-vanille-caviar": [
    "gender:unisex",
    "note:salt",
    "note:spicy",
    "note:woody",
    "note:aquatic",
    "note:fresh",
    "note:gourmand",
    "note:vanilla",
    "note:fruity"
  ],
  "belnu-chai-fleur": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:jasmine",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:milk",
    "note:vanilla"
  ],
  "belnu-incense-antique": [
    "gender:unisex",
    "note:amber",
    "note:incense",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:fresh",
    "note:vetiver"
  ],
  "belnu-rose-steady": [
    "gender:unisex",
    "note:rose",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:fresh",
    "note:citrus",
    "note:cedar",
    "note:vetiver",
    "note:fruity"
  ],
  "boadicea-the-victorious-1907": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:citrus",
    "note:woody",
    "note:aquatic",
    "note:spicy",
    "note:leather",
    "note:fresh",
    "note:fruity"
  ],
  "boadicea-the-victorious-ardent": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:musk",
    "note:fruity",
    "note:rose",
    "note:jasmine",
    "note:vanilla",
    "note:cedar"
  ],
  "boadicea-the-victorious-bodacious": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:leather",
    "note:musk",
    "note:iris",
    "note:rose",
    "note:vanilla",
    "note:vetiver",
    "note:suede"
  ],
  "boadicea-the-victorious-glorious": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:musk",
    "note:smoky",
    "note:fruity",
    "note:rose",
    "note:jasmine",
    "note:vanilla",
    "note:tobacco",
    "note:vetiver"
  ],
  "boadicea-the-victorious-harmonius": [
    "gender:unisex",
    "note:amber",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:spicy",
    "note:musk",
    "note:smoky",
    "note:fresh",
    "note:fruity",
    "note:tobacco",
    "note:cedar"
  ],
  "brandt-genesis": [
    "gender:unisex",
    "note:incense",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:musk",
    "note:fresh",
    "note:cedar",
    "note:leather"
  ],
  "brandt-guava-sorbet": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:woody",
    "note:musk",
    "note:jasmine",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:vanilla",
    "note:fruity"
  ],
  "casamorati-dama-bianca": [
    "gender:unisex",
    "note:floral",
    "note:citrus",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:musk",
    "note:fresh",
    "note:jasmine",
    "note:vanilla"
  ],
  "casamorati-italica": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:aquatic",
    "note:musk",
    "note:fresh",
    "note:fruity",
    "note:iris",
    "note:rose",
    "note:cedar"
  ],
  "casamorati-lira": [
    "gender:unisex",
    "note:woody",
    "note:gourmand",
    "note:spicy",
    "note:musk",
    "note:vanilla",
    "note:cedar",
    "note:milk"
  ],
  "casamorati-mefisto": [
    "gender:unisex",
    "note:floral",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:leather",
    "note:smoky",
    "note:fresh",
    "note:rose",
    "note:tobacco",
    "note:milk"
  ],
  "cirque-du-soleil-leau-de-parfum": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:woody",
    "note:musk",
    "note:citrus",
    "note:gourmand",
    "note:vanilla",
    "note:fruity"
  ],
  "clive-christian-blonde-amber": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:jasmine",
    "note:citrus",
    "note:gourmand",
    "note:iris",
    "note:tobacco",
    "note:vanilla"
  ],
  "clive-christian-jump-up-and-kiss-me-hedonistic": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:smoky",
    "note:woody",
    "note:musk",
    "note:jasmine",
    "note:citrus",
    "note:gourmand",
    "note:vanilla",
    "note:leather",
    "note:tobacco",
    "note:fruity"
  ],
  "clive-christian-strange-heavens-out-of-the-blue": [
    "gender:feminine",
    "note:amber",
    "note:rose",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:jasmine",
    "note:citrus",
    "note:gourmand",
    "note:vanilla"
  ],
  "clive-christian-town-and-country": [
    "gender:masculine",
    "note:amber",
    "note:incense",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:cedar"
  ],
  "dannam-chapter-1-discovery-set-enchanting-vietnam": [
    "gender:unisex",
    "note:aquatic"
  ],
  "dannam-chapter-2-discovery-set-memories-of-japan": [
    "gender:unisex",
    "note:woody",
    "note:gourmand",
    "note:fruity"
  ],
  "dannam-japanese-whiskey": [
    "gender:unisex",
    "note:amber",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:citrus"
  ],
  "dannam-mango-sticky-rice": [
    "gender:unisex",
    "note:musk",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:milk",
    "note:vanilla",
    "note:fruity"
  ],
  "dannam-matcha-soft-serve": [
    "gender:unisex",
    "note:floral",
    "note:fresh",
    "note:gourmand",
    "note:milk",
    "note:vanilla"
  ],
  "dannam-pomelo-oolong": [
    "gender:unisex",
    "note:floral",
    "note:woody",
    "note:musk",
    "note:jasmine",
    "note:fresh",
    "note:citrus",
    "note:cedar",
    "note:vetiver",
    "note:magnolia"
  ],
  "dannam-strawberry-mochi": [
    "gender:unisex",
    "note:vanilla",
    "note:gourmand",
    "note:fruity"
  ],
  "dannam-vietnamese-coffee": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:cedar",
    "note:gourmand",
    "note:milk"
  ],
  "dannam-white-rice": [
    "gender:unisex",
    "note:floral",
    "note:woody",
    "note:musk",
    "note:jasmine",
    "note:fresh",
    "note:cedar",
    "note:gourmand",
    "note:iris"
  ],
  "dorsay-c-g": [
    "gender:unisex",
    "note:floral",
    "note:woody",
    "note:musk",
    "note:fresh",
    "note:citrus",
    "note:gourmand"
  ],
  "dorsay-e-q": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:spicy",
    "note:musk",
    "note:jasmine",
    "note:iris"
  ],
  "dorsay-flower-lust": [
    "gender:unisex",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:citrus",
    "note:gourmand",
    "note:milk",
    "note:vanilla"
  ],
  "dorsay-g-a": [
    "gender:unisex",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:fresh",
    "note:citrus",
    "note:cedar",
    "note:iris",
    "note:leather",
    "note:fruity"
  ],
  "dorsay-holy-berry": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:oud",
    "note:jasmine",
    "note:gourmand",
    "note:milk",
    "note:iris",
    "note:vanilla",
    "note:fruity"
  ],
  "dorsay-olfactory-discoveries-set": [
    "gender:unisex",
    "note:rose",
    "note:floral"
  ],
  "dorsay-r-b": [
    "gender:unisex",
    "note:rose",
    "note:incense",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:musk"
  ],
  "dorsay-rose-blaze": [
    "gender:unisex",
    "note:floral",
    "note:gourmand",
    "note:spicy",
    "note:smoky",
    "note:jasmine",
    "note:vanilla",
    "note:tobacco",
    "note:amber",
    "note:rose",
    "note:fruity"
  ],
  "fleurit-parfums-fleuriste": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:woody",
    "note:musk",
    "note:fresh",
    "note:citrus"
  ],
  "fleurit-parfums-fleurs-de-d-esse": [
    "gender:unisex",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:fresh",
    "note:citrus",
    "note:cedar"
  ],
  "fleurit-parfums-fleurs-de-tabac": [
    "gender:unisex",
    "note:suede",
    "note:incense",
    "note:spicy",
    "note:smoky",
    "note:musk",
    "note:citrus",
    "note:gourmand",
    "note:vanilla",
    "note:leather",
    "note:tobacco"
  ],
  "fleurit-parfums-g-teau-des-anges": [
    "gender:unisex",
    "note:rose",
    "note:floral",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:milk",
    "note:vanilla",
    "note:fruity"
  ],
  "fleurit-parfums-sainte-fum-e": [
    "gender:unisex",
    "note:amber",
    "note:incense",
    "note:smoky",
    "note:musk",
    "note:citrus",
    "note:iris",
    "note:fruity"
  ],
  "french-cowboy-mezcal-chocolat": [
    "gender:unisex",
    "note:amber",
    "note:incense",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:musk",
    "note:vetiver",
    "note:citrus",
    "note:cedar",
    "note:gourmand",
    "note:leather"
  ],
  "french-cowboy-pear-pavlova": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:spicy",
    "note:musk",
    "note:jasmine",
    "note:gourmand"
  ],
  "gallivant-bukhara": [
    "gender:unisex",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:jasmine",
    "note:fresh",
    "note:iris"
  ],
  "gallivant-gdansk": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:incense",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:musk",
    "note:aquatic",
    "note:gourmand",
    "note:leather",
    "note:tobacco"
  ],
  "gallivant-istanbul": [
    "gender:unisex",
    "note:amber",
    "note:incense",
    "note:spicy",
    "note:woody",
    "note:oud",
    "note:musk",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:vanilla"
  ],
  "gallivant-london": [
    "gender:unisex",
    "note:amber",
    "note:citrus",
    "note:woody",
    "note:aquatic",
    "note:spicy",
    "note:smoky",
    "note:fresh",
    "note:incense",
    "note:salt",
    "note:suede",
    "note:rose",
    "note:floral",
    "note:iris",
    "note:leather"
  ],
  "gallivant-tokyo": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:incense",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:citrus",
    "note:cedar",
    "note:iris"
  ],
  "giardini-di-toscana-bianco-latte": [
    "gender:unisex",
    "note:oud",
    "note:musk",
    "note:gourmand",
    "note:milk",
    "note:vanilla"
  ],
  "giardini-di-toscana-blu-mare": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:salt",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:fruity"
  ],
  "giardini-di-toscana-discovery-set": [
    "gender:unisex",
    "note:aquatic",
    "note:fresh"
  ],
  "giardini-di-toscana-oro-e-miele": [
    "gender:unisex",
    "note:rose",
    "note:floral",
    "note:woody",
    "note:musk",
    "note:cedar",
    "note:gourmand",
    "note:iris",
    "note:vanilla"
  ],
  "giardini-di-toscana-ricordami": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:woody",
    "note:musk",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:cedar",
    "note:fig",
    "note:vetiver",
    "note:magnolia",
    "note:fruity"
  ],
  "giardini-di-toscana-verde-respiro": [
    "gender:unisex",
    "note:amber",
    "note:woody",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:iris",
    "note:vanilla",
    "note:fruity"
  ],
  "goldfield-banks-ingenious-ginger": [
    "gender:unisex",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:aquatic",
    "note:fresh",
    "note:rose",
    "note:cedar",
    "note:salt"
  ],
  "goldfield-banks-pacific-rock-flower": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:rose",
    "note:jasmine",
    "note:vetiver"
  ],
  "goldfield-banks-pacific-rock-moss": [
    "gender:unisex",
    "note:citrus",
    "note:woody",
    "note:fresh",
    "note:vetiver",
    "note:floral",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:fruity",
    "note:jasmine",
    "note:salt"
  ],
  "goldfield-banks-rose-magnitude": [
    "gender:unisex",
    "note:oud",
    "note:floral",
    "note:woody",
    "note:gourmand",
    "note:spicy",
    "note:leather",
    "note:musk",
    "note:smoky",
    "note:fruity",
    "note:jasmine",
    "note:vanilla",
    "note:tobacco",
    "note:incense",
    "note:suede"
  ],
  "goldfield-banks-sunset-hour": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:musk",
    "note:fresh",
    "note:rose",
    "note:jasmine",
    "note:vanilla",
    "note:magnolia"
  ],
  "hellenist-la-nuit-des-300": [
    "gender:masculine",
    "note:amber",
    "note:woody",
    "note:musk",
    "note:fresh",
    "note:citrus",
    "note:gourmand"
  ],
  "hellenist-le-chant-dachille": [
    "gender:unisex",
    "note:salt",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:aquatic",
    "note:citrus",
    "note:vetiver"
  ],
  "hellenist-les-bras-de-morphee": [
    "gender:unisex",
    "note:floral",
    "note:gourmand",
    "note:iris",
    "note:vanilla",
    "note:fruity"
  ],
  "hellenist-les-dieux-aux-bains": [
    "gender:unisex",
    "note:rose",
    "note:floral",
    "note:woody",
    "note:fresh",
    "note:citrus",
    "note:vetiver"
  ],
  "hellenist-lombre-dart-mis": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:jasmine",
    "note:fresh",
    "note:citrus",
    "note:vetiver"
  ],
  "investi-parfums-discovery-set": [
    "gender:unisex",
    "note:vanilla",
    "note:fresh",
    "note:gourmand"
  ],
  "investi-parfums-find-me": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:spicy",
    "note:musk",
    "note:jasmine",
    "note:fresh",
    "note:gourmand",
    "note:vanilla",
    "note:fruity",
    "note:smoky",
    "note:woody",
    "note:fig"
  ],
  "jovoy-parfums-discovery-kit": [
    "gender:unisex",
    "note:amber",
    "note:spicy",
    "note:musk",
    "note:gourmand",
    "note:vanilla"
  ],
  "jovoy-parfums-fire-at-will": [
    "gender:unisex",
    "note:amber",
    "note:woody",
    "note:oud",
    "note:musk",
    "note:gourmand",
    "note:vanilla",
    "note:vetiver"
  ],
  "jovoy-parfums-musc-pallas": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:musk",
    "note:aquatic",
    "note:citrus",
    "note:gourmand",
    "note:iris",
    "note:fruity"
  ],
  "jovoy-parfums-remember-me": [
    "gender:unisex",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:citrus",
    "note:cedar",
    "note:gourmand",
    "note:milk",
    "note:vanilla"
  ],
  "kerosene-blackmail": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:woody",
    "note:aquatic",
    "note:musk",
    "note:rose",
    "note:cedar",
    "note:salt"
  ],
  "kerosene-followed": [
    "gender:unisex",
    "note:floral",
    "note:gourmand",
    "note:spicy",
    "note:musk",
    "note:rose",
    "note:vanilla"
  ],
  "kerosene-summer-of-84": [
    "gender:unisex",
    "note:floral",
    "note:citrus",
    "note:gourmand",
    "note:rose",
    "note:vanilla"
  ],
  "kerosene-sweetly-known": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:floral",
    "note:woody",
    "note:gourmand",
    "note:musk",
    "note:smoky",
    "note:rose",
    "note:vanilla"
  ],
  "kerosene-unknown-pleasures": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:gourmand",
    "note:rose",
    "note:vanilla"
  ],
  "kerosene-vanilified": [
    "gender:unisex",
    "note:floral",
    "note:citrus",
    "note:musk",
    "note:fresh",
    "note:fruity",
    "note:rose"
  ],
  "kerosene-walk-the-sea": [
    "gender:unisex",
    "note:floral",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:musk",
    "note:fresh",
    "note:fruity",
    "note:rose",
    "note:vanilla",
    "note:cedar",
    "note:amber",
    "note:oud",
    "note:spicy",
    "note:jasmine",
    "note:citrus",
    "note:iris"
  ],
  "les-indemodables-ambre-supreme": [
    "gender:unisex",
    "note:amber",
    "note:salt",
    "note:floral",
    "note:spicy",
    "note:jasmine",
    "note:aquatic",
    "note:citrus"
  ],
  "les-indemodables-chypre-azural": [
    "gender:unisex",
    "note:amber",
    "note:salt",
    "note:floral",
    "note:jasmine",
    "note:aquatic",
    "note:fresh",
    "note:citrus"
  ],
  "les-indemodables-discovery-kit": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:floral",
    "note:musk",
    "note:citrus",
    "note:iris",
    "note:leather",
    "note:vanilla"
  ],
  "les-indemodables-foug-re-meraude": [
    "gender:unisex",
    "note:citrus",
    "note:woody",
    "note:aquatic",
    "note:musk",
    "note:fresh",
    "note:cedar",
    "note:salt",
    "gender:masculine",
    "note:rose",
    "note:hay",
    "note:floral",
    "note:gourmand",
    "note:suede",
    "note:smoky",
    "note:jasmine",
    "note:leather",
    "note:tobacco",
    "note:fruity"
  ],
  "les-indemodables-immortelle-solaire": [
    "gender:unisex",
    "note:oud",
    "note:citrus",
    "note:woody",
    "note:spicy",
    "note:leather",
    "note:smoky",
    "note:fresh",
    "note:incense",
    "note:vetiver",
    "note:fruity"
  ],
  "les-indemodables-iris-perle": [
    "gender:unisex",
    "note:floral",
    "note:jasmine",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:iris"
  ],
  "les-indemodables-musc-des-sables": [
    "gender:unisex",
    "note:amber",
    "note:salt",
    "note:musk",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:iris"
  ],
  "les-indemodables-oranger-sirocco": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:spicy",
    "note:citrus",
    "note:gourmand"
  ],
  "les-indemodables-patchouli-noisette": [
    "gender:unisex",
    "note:amber",
    "note:spicy",
    "note:fresh",
    "note:citrus",
    "note:gourmand"
  ],
  "les-indemodables-rose-de-jamal": [
    "gender:unisex",
    "note:rose",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:fresh",
    "note:cedar"
  ],
  "les-indemodables-vanille-havane": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:gourmand",
    "note:vanilla",
    "note:leather",
    "note:tobacco"
  ],
  "liis-bo": [
    "gender:unisex",
    "note:incense",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:cedar",
    "note:gourmand",
    "note:vanilla",
    "note:tobacco"
  ],
  "liis-celestial-object": [
    "gender:unisex",
    "note:incense",
    "note:spicy",
    "note:gourmand",
    "note:smoky"
  ],
  "liis-choux-choux": [
    "gender:unisex",
    "note:salt",
    "note:woody",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:vanilla"
  ],
  "liis-ethereal-wave": [
    "gender:unisex",
    "note:woody",
    "note:citrus",
    "note:spicy",
    "note:musk"
  ],
  "liis-floating": [
    "gender:unisex",
    "note:amber",
    "note:woody",
    "note:musk",
    "note:citrus",
    "note:fruity"
  ],
  "liis-flower-glyph": [
    "gender:unisex",
    "note:floral",
    "note:jasmine",
    "note:fresh",
    "note:gourmand",
    "note:fruity"
  ],
  "liis-in-this-world": [
    "gender:unisex",
    "note:woody",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:fig",
    "note:fruity"
  ],
  "liis-lucienne": [
    "gender:unisex",
    "note:amber",
    "note:hay",
    "note:floral",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:magnolia",
    "note:fruity"
  ],
  "liis-of-true-minds": [
    "gender:unisex",
    "note:citrus",
    "note:woody",
    "note:aquatic",
    "note:musk",
    "note:cedar",
    "note:salt",
    "note:suede",
    "note:iris",
    "note:leather"
  ],
  "liis-rose-struck": [
    "gender:unisex",
    "note:rose",
    "note:floral",
    "note:woody",
    "note:fresh",
    "note:fruity"
  ],
  "liis-studied": [
    "gender:unisex",
    "note:amber",
    "note:musk",
    "note:gourmand",
    "note:iris",
    "note:fruity"
  ],
  "liis-unseen-discovery-kit": [
    "gender:unisex",
    "note:amber",
    "note:woody",
    "note:spicy",
    "note:musk"
  ],
  "liis-vivid-discovery-kit": [
    "gender:unisex",
    "note:rose",
    "note:floral"
  ],
  "lorenzo-pazzaglia-black-sea": [
    "gender:unisex",
    "note:amber",
    "note:salt",
    "note:floral",
    "note:musk",
    "note:aquatic",
    "note:fresh",
    "note:citrus"
  ],
  "lorenzo-pazzaglia-dream-sea": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:salt",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:aquatic",
    "note:fresh",
    "note:cedar",
    "note:gourmand",
    "note:vanilla"
  ],
  "lorenzo-pazzaglia-evil-angel": [
    "gender:unisex",
    "note:incense",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:musk",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:cedar",
    "note:gourmand",
    "note:vanilla",
    "note:tobacco",
    "note:fruity"
  ],
  "lorenzo-pazzaglia-green-island": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:salt",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:cedar",
    "note:gourmand",
    "note:vetiver",
    "note:fruity"
  ],
  "lorenzo-pazzaglia-sex-sea": [
    "gender:unisex",
    "note:amber",
    "note:salt",
    "note:spicy",
    "note:woody",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:cedar",
    "note:fig",
    "note:fruity"
  ],
  "lorenzo-pazzaglia-speachless": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:oud",
    "note:musk",
    "note:jasmine",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:vanilla",
    "note:vetiver",
    "note:magnolia",
    "note:fruity"
  ],
  "lorenzo-pazzaglia-summer-hammer": [
    "gender:unisex",
    "note:amber",
    "note:salt",
    "note:woody",
    "note:musk",
    "note:aquatic",
    "note:citrus",
    "note:gourmand",
    "note:milk",
    "note:vetiver",
    "note:fruity"
  ],
  "lorenzo-pazzaglia-sun-gria": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:fresh",
    "note:citrus",
    "note:cedar",
    "note:gourmand",
    "note:vanilla",
    "note:fruity"
  ],
  "lorenzo-pazzaglia-van-py-rhum": [
    "gender:unisex",
    "note:woody",
    "note:vanilla",
    "note:oud",
    "note:gourmand"
  ],
  "lorenzo-pazzaglia-van-sea": [
    "gender:unisex",
    "note:amber",
    "note:salt",
    "note:woody",
    "note:oud",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:vanilla"
  ],
  "mind-games-blockade": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:fruity",
    "note:rose",
    "note:vanilla",
    "note:cedar"
  ],
  "mind-games-french-defense": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:spicy",
    "note:musk",
    "note:fruity",
    "note:iris",
    "note:vanilla"
  ],
  "mind-games-jadoube": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:spicy",
    "note:fresh",
    "note:fruity",
    "note:rose",
    "note:vanilla",
    "note:cedar"
  ],
  "mind-games-queening": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:aquatic",
    "note:leather",
    "note:fruity",
    "note:rose"
  ],
  "narcotica-doza": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:floral",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:musk",
    "note:fresh",
    "note:jasmine",
    "note:vanilla"
  ],
  "narcotica-dulce-diablo": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:woody",
    "note:gourmand",
    "note:spicy",
    "note:musk",
    "note:fruity",
    "note:jasmine",
    "note:vanilla",
    "note:incense",
    "note:cedar"
  ],
  "narcotica-happy-dust": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:musk",
    "note:fruity",
    "note:iris",
    "note:jasmine",
    "note:vanilla"
  ],
  "narcotica-limonata": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:woody",
    "note:gourmand",
    "note:spicy",
    "note:leather",
    "note:smoky",
    "note:vanilla",
    "note:tobacco",
    "note:incense",
    "note:cedar"
  ],
  "narcotica-maniac": [
    "gender:unisex",
    "note:woody",
    "note:gourmand",
    "note:smoky"
  ],
  "narcotica-narco-oasis": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:musk",
    "note:fresh",
    "note:jasmine",
    "note:vanilla",
    "note:milk"
  ],
  "narcotica-narcotica-signature": [
    "gender:unisex",
    "note:woody",
    "note:gourmand",
    "note:musk",
    "note:fruity",
    "note:vanilla"
  ],
  "orto-parisi-bergamask": [
    "gender:unisex",
    "note:oud",
    "note:floral",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:musk",
    "note:milk"
  ],
  "orto-parisi-boccanera": [
    "gender:unisex",
    "note:amber",
    "note:citrus",
    "note:woody",
    "note:aquatic",
    "note:musk",
    "note:fruity",
    "note:gourmand",
    "note:spicy",
    "note:leather",
    "note:smoky",
    "note:vanilla",
    "note:incense",
    "note:cedar"
  ],
  "orto-parisi-megamare": [
    "gender:unisex",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:musk",
    "note:fresh",
    "note:cedar"
  ],
  "orto-parisi-risvelium": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:musk",
    "note:fruity",
    "note:iris",
    "note:jasmine",
    "note:vanilla",
    "note:cedar"
  ],
  "orto-parisi-seminalis": [
    "gender:unisex",
    "note:oud",
    "note:floral",
    "note:woody",
    "note:leather",
    "note:smoky",
    "note:rose",
    "note:tobacco",
    "note:cedar"
  ],
  "orto-parisi-stercus": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:woody",
    "note:gourmand",
    "note:spicy",
    "note:musk",
    "note:smoky",
    "note:fruity",
    "note:vanilla",
    "note:vetiver",
    "note:cedar"
  ],
  "perfumology-blyss": [
    "gender:unisex",
    "note:amber",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:leather",
    "note:musk",
    "note:smoky",
    "note:vanilla",
    "note:cedar",
    "note:floral",
    "note:citrus",
    "note:fresh"
  ],
  "perfumology-lima": [
    "gender:unisex",
    "note:woody",
    "note:gourmand",
    "note:musk",
    "note:fresh",
    "note:fruity",
    "note:vanilla",
    "note:cedar"
  ],
  "pernoire-anelo": [
    "gender:masculine",
    "note:amber",
    "note:rose",
    "note:salt",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:vetiver",
    "note:magnolia",
    "note:fruity"
  ],
  "pernoire-melos": [
    "gender:unisex",
    "note:spicy",
    "note:woody",
    "note:oud",
    "note:citrus",
    "note:fruity"
  ],
  "pernoire-poka": [
    "gender:unisex",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:cedar",
    "note:gourmand",
    "note:vanilla",
    "note:fruity"
  ],
  "pernoire-vitias": [
    "gender:unisex",
    "note:amber",
    "note:salt",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:iris"
  ],
  "pernoire-yuma": [
    "gender:unisex",
    "note:amber",
    "note:spicy",
    "note:woody",
    "note:oud",
    "note:musk",
    "note:fresh",
    "note:citrus",
    "note:vetiver"
  ],
  "rania-j-ambre-loup": [
    "gender:unisex",
    "note:amber",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:oud",
    "note:cedar",
    "note:gourmand",
    "note:vanilla",
    "note:tobacco"
  ],
  "rania-j-jasmin-kama": [
    "gender:unisex",
    "note:rose",
    "note:floral",
    "note:woody",
    "note:oud",
    "note:musk",
    "note:jasmine",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:vanilla"
  ],
  "rania-j-samar-kand-extrait": [
    "gender:unisex",
    "note:amber",
    "note:suede",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:oud",
    "note:musk",
    "note:citrus",
    "note:gourmand",
    "note:leather",
    "note:fruity"
  ],
  "rania-j-t-habanero": [
    "gender:unisex",
    "note:incense",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:oud",
    "note:leather",
    "note:tobacco"
  ],
  "room-1015-cherry-punk": [
    "gender:unisex",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:jasmine",
    "note:gourmand",
    "note:leather",
    "note:fruity"
  ],
  "room-1015-cherry-punk-extrait-de-parfum": [
    "gender:unisex",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:jasmine",
    "note:gourmand",
    "note:leather",
    "note:fruity"
  ],
  "room-1015-electric-wood-extrait-de-parfum": [
    "gender:unisex",
    "note:amber",
    "note:incense",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:fresh",
    "note:cedar",
    "note:gourmand",
    "note:iris",
    "note:vetiver",
    "note:vanilla"
  ],
  "room-1015-love-o-matic": [
    "gender:unisex",
    "note:amber",
    "note:woody",
    "note:musk",
    "note:fresh",
    "note:citrus",
    "note:cedar",
    "note:fruity"
  ],
  "room-1015-poppy-riot": [
    "gender:unisex",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:musk",
    "note:fresh",
    "note:citrus",
    "note:cedar",
    "note:gourmand",
    "note:milk",
    "note:tobacco",
    "note:fruity"
  ],
  "room-1015-wave-child": [
    "gender:unisex",
    "note:amber",
    "note:salt",
    "note:woody",
    "note:aquatic",
    "note:citrus",
    "note:fruity"
  ],
  "sora-dora-gladiator": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:gourmand",
    "note:musk",
    "note:fruity",
    "note:vanilla"
  ],
  "sora-dora-jany": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:leather",
    "note:smoky",
    "note:fruity",
    "note:rose",
    "note:vetiver"
  ],
  "sora-dora-mallow": [
    "gender:unisex",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:musk",
    "note:fresh",
    "note:fruity",
    "note:vanilla"
  ],
  "sora-dora-mandorle": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:spicy",
    "note:leather",
    "note:musk",
    "note:smoky",
    "note:vanilla",
    "note:tobacco"
  ],
  "sora-dora-ylop": [
    "gender:unisex",
    "note:amber",
    "note:woody",
    "note:gourmand",
    "note:spicy",
    "note:leather",
    "note:musk",
    "note:smoky",
    "note:fruity",
    "note:vanilla",
    "note:suede"
  ],
  "spiritica-atmayatra": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:woody",
    "note:gourmand",
    "note:spicy",
    "note:leather",
    "note:musk",
    "note:smoky",
    "note:jasmine",
    "note:vanilla"
  ],
  "spiritica-jeffrey": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:citrus",
    "note:gourmand",
    "note:spicy",
    "note:fruity"
  ],
  "spiritica-leonarda": [
    "gender:unisex",
    "note:citrus",
    "note:gourmand",
    "note:aquatic",
    "note:fresh",
    "note:vanilla",
    "note:salt",
    "note:milk"
  ],
  "spiritica-lynch-aka-smoke-styrax": [
    "gender:unisex",
    "note:citrus",
    "note:woody",
    "note:spicy",
    "note:musk",
    "note:fresh",
    "note:cedar"
  ],
  "spiritica-mango-macumba": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:woody",
    "note:spicy",
    "note:musk",
    "note:smoky",
    "note:fresh",
    "note:incense",
    "note:cedar"
  ],
  "spiritica-yuzuyakuza": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:floral",
    "note:gourmand",
    "note:spicy",
    "note:musk",
    "note:smoky",
    "note:fruity",
    "note:jasmine",
    "note:incense",
    "note:milk"
  ],
  "twentysecondofmay-bees-home": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:incense",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:jasmine",
    "note:citrus",
    "note:gourmand",
    "note:vanilla"
  ],
  "twentysecondofmay-frosted-flame": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:jasmine",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:cedar",
    "note:leather"
  ],
  "twentysecondofmay-roots-of-kente": [
    "gender:unisex",
    "note:amber",
    "note:woody",
    "note:musk",
    "note:gourmand",
    "note:milk",
    "note:vanilla"
  ],
  "twentysecondofmay-sunbeds-and-daydreams": [
    "gender:unisex",
    "note:amber",
    "note:salt",
    "note:floral",
    "note:woody",
    "note:oud",
    "note:musk",
    "note:jasmine",
    "note:aquatic",
    "note:fresh",
    "note:gourmand"
  ],
  "xerjoff-accento": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:aquatic",
    "note:fresh",
    "note:fruity",
    "note:vetiver",
    "note:cedar"
  ],
  "xerjoff-erba-gold": [
    "gender:unisex",
    "note:amber",
    "note:citrus",
    "note:woody",
    "note:aquatic",
    "note:spicy",
    "note:musk",
    "note:fresh"
  ],
  "xerjoff-erba-pura": [
    "gender:unisex",
    "note:floral",
    "note:citrus",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:smoky",
    "note:fresh",
    "note:jasmine",
    "note:vanilla",
    "note:tobacco"
  ],
  "xerjoff-la-capitale": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:musk",
    "note:fresh",
    "note:fruity",
    "note:iris",
    "note:jasmine",
    "note:vanilla",
    "note:vetiver"
  ],
  "xerjoff-louis-xv-1722-rose": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:aquatic",
    "note:spicy",
    "note:musk",
    "note:fresh",
    "note:fruity"
  ],
  "xerjoff-naxos": [
    "gender:unisex",
    "note:floral",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:musk",
    "note:fruity",
    "note:rose",
    "note:jasmine",
    "note:vanilla",
    "note:cedar"
  ],
  "xerjoff-torino-21": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:leather",
    "note:fruity",
    "note:rose",
    "note:vanilla"
  ],
  "xerjoff-torino-22": [
    "gender:unisex",
    "note:floral",
    "note:citrus",
    "note:aquatic",
    "note:musk",
    "note:fresh",
    "note:fruity",
    "note:rose",
    "note:jasmine"
  ],
  "xerjoff-torino-24": [
    "gender:unisex",
    "note:amber",
    "note:citrus",
    "note:woody",
    "note:gourmand",
    "note:aquatic",
    "note:spicy",
    "note:musk",
    "note:fresh",
    "note:fruity",
    "note:vanilla"
  ],
  "xerjoff-torino-25": [
    "gender:unisex",
    "note:amber",
    "note:citrus",
    "note:gourmand",
    "note:musk",
    "note:fresh",
    "note:fruity",
    "note:vanilla"
  ],
  "xtrait-perfumery": [
    "gender:unisex"
  ],
  "zernell-gillie-blues": [
    "gender:unisex",
    "note:floral",
    "note:woody",
    "note:oud",
    "note:aquatic",
    "note:gourmand",
    "note:magnolia"
  ],
  "zernell-gillie-disco": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:citrus",
    "note:gourmand",
    "note:iris",
    "note:leather",
    "note:vanilla"
  ],
  "zernell-gillie-hip-hop": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:musk",
    "note:citrus",
    "note:gourmand",
    "note:vanilla",
    "note:tobacco"
  ],
  "zernell-gillie-house": [
    "gender:unisex",
    "note:amber",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:aquatic",
    "note:fresh",
    "note:citrus",
    "note:cedar",
    "note:fruity"
  ],
  "zernell-gillie-jazz": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:floral",
    "note:spicy",
    "note:smoky",
    "note:woody",
    "note:musk",
    "note:jasmine",
    "note:fresh",
    "note:citrus",
    "note:gourmand",
    "note:vanilla",
    "note:tobacco"
  ],
  "zernell-gillie-r-and-b": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:floral",
    "note:woody",
    "note:cedar",
    "note:gourmand",
    "note:fruity"
  ],
  "zernell-gillie-techno": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:floral",
    "note:spicy",
    "note:woody",
    "note:musk",
    "note:citrus",
    "note:cedar",
    "note:leather",
    "note:fruity"
  ]
  };
  window.XTRAIT_PRODUCT_TAGS = map;
  window.xtraitMergeProductTags = function (handle, existing) {
    var seen = {};
    var out = [];
    function add(tag) {
      tag = String(tag || '').trim().toLowerCase();
      if (!tag || seen[tag]) return;
      seen[tag] = true;
      out.push(tag);
    }
    (Array.isArray(existing) ? existing : []).forEach(add);
    (map[handle] || []).forEach(add);
    return out;
  };
})();
